/**
 * Shared timer key helper for Step1/Step2.
 * Builds a session-scoped localStorage key so Timer can resume elapsed time after reload.
 */
import { useAppSelector } from 'store/hooks'
import { getSessionId } from 'store/slices/test'

interface TimerResumeResult {
  timerKey: string
}

const useTimerResume = (stepPrefix: string): TimerResumeResult => {
  const sessionId = useAppSelector(getSessionId)
  const timerKey = sessionId ? `${stepPrefix}_${sessionId}` : stepPrefix

  return { timerKey }
}

export default useTimerResume
